"use strict";
var core_1 = require('@angular/core');
var JustgageComponent = (function () {
    function JustgageComponent(elementRef) {
        this.elementRef = elementRef;
        this.options = {};
        this.value = 0;
        this.max = 100;
    }
    JustgageComponent.prototype.ngOnInit = function () {
        this.create();
    };
    JustgageComponent.prototype.ngOnChanges = function (changes) {
        if (this.justgage) {
            if (changes['options']) {
                this.elementRef.nativeElement.innerHTML = '';
                this.create();
            }
            else if (changes['max'] || changes['value']) {
                this.justgage.refresh(this.value, this.max);
            }
        }
    };
    JustgageComponent.prototype.create = function () {
        delete this.options.id;
        this.options.parentNode = this.elementRef.nativeElement;
        this.options.max = this.max;
        this.options.value = this.value;
        this.justgage = new JustGage(this.options);
    };
    JustgageComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'justgage',
                    template: "\n\n  ",
                    styles: [":host {  display: block; }"]
                },] },
    ];
    /** @nocollapse */
    JustgageComponent.ctorParameters = [
        { type: core_1.ElementRef, },
    ];
    JustgageComponent.propDecorators = {
        'options': [{ type: core_1.Input },],
        'value': [{ type: core_1.Input },],
        'max': [{ type: core_1.Input },],
    };
    return JustgageComponent;
}());
exports.JustgageComponent = JustgageComponent;
//# sourceMappingURL=justgage.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-justgage/dist/justgage.component.js
// module id = 915
// module chunks = 3